import * as React from 'react';
const StanchezzaFisicaEMentaleIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{fill:${secondaryColor ||
        '#ffcf38'}}.prefix__cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px;stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M100.46 94.44v20.38s9.26 0 9.26-7.41V88.89c0-3.7-.64-7.41-9.26-7.41-5.56 0-11.11 1.85-14.53 5.21-6.88 6.77-14.19 13.25-14.19 18 0 4.45 3.27 7.09 6.9 10.34 3.9 3.51 10.34 8.62 10.34 8.62l-3.32 18.97M94.29 142.61l5.8-21.2M94.29 110.55l-3.58-3.29M100.46 98.15l-9.75 9.11"
      className="prefix__cls-3"
    />
    <circle cx={121.77} cy={84.25} r={6.48} className="prefix__cls-3" />
    <path
      d="m72.68 108.52 5.97 16.72-3.32 17.37M87.55 104.25l3.16 3.01"
      className="prefix__cls-3"
    />
    <rect
      width={34.13}
      height={17.66}
      x={80.73}
      y={54.5}
      rx={3.63}
      ry={3.63}
      style={{
        stroke: secondaryColor || '#ffcf38',
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
      }}
    />
    <rect
      width={5.23}
      height={9.68}
      x={114.04}
      y={58.49}
      className="prefix__cls-1"
      rx={1.6}
      ry={1.6}
    />
    <rect
      width={5.6}
      height={10.19}
      x={84.61}
      y={58.24}
      className="prefix__cls-1"
      rx={0.9}
      ry={0.9}
    />
  </svg>
);
export default StanchezzaFisicaEMentaleIcon;
